import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper'
import 'swiper/css/pagination'
import './five.css'
import { fiveSteps } from '../../../../routes'
import styles from './styles.module.scss'
import parse from "html-react-parser";

const FiveSteps = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_block}>
        <div className={styles.left}>
          <p className={styles.title}>Пять шагов — и вы в команде</p>
        </div>
        <div className={styles.right}>
          <p className={styles.title}>
            Как начать карьеру в Generium?
          </p>
          <div className={styles.slider_block}>
            <div className="slider_main_mod_fs">
            <Swiper
              spaceBetween={10}
              initialSlide={0}
              slidesPerView={1}
              slideToClickedSlide
              navigation
              modules={[Navigation]}
              // breakpoints={{
              //   1440: {
              //     slidesPerView: 1,
              //     spaceBetween: 0
              //   },
              //   1366: {
              //     slidesPerView: 3.6,
              //     spaceBetween: 0
              //   },
              //   1025: {
              //     slidesPerView: 3,
              //     spaceBetween: 0
              //   },
              //   769: {
              //     slidesPerView: 2.8,
              //     spaceBetween: 10
              //   },
              //   768: {
              //     slidesPerView: 3,
              //     spaceBetween: 10,
              //     initialSlide: 0
              //   },
              //   596: {
              //     slidesPerView: 2,
              //     spaceBetween: 10,
              //     initialSlide: 0
              //   },
              //   320: {
              //     slidesPerView: 1.2,
              //     spaceBetween: 10,
              //     initialSlide: 0
              //   }
              // }}
            >
              {fiveSteps.map(item => (
                <SwiperSlide key={item.id}>
                  <div className='wrapper-block'>
                    <div className='wrapper-block-left'>
                      <div className='wrapper-block-left-img'>
                        <p className='wrapper-block-left-img-p'></p>
                        <p className='wrapper-block-left-img-id'>{item.id}</p>
                      </div>
                      <p className='wrapper-block-title' style={{ maxWidth: '100%' }}>
                        {<>{parse(item.title)}</>}
                      </p>
                    </div>
                    <p className='wrapper-block-text'>
                      <span>{item.text}</span>
                    </p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FiveSteps
